import { ReactNode, useEffect, useState } from "react";
import NotImplemented from "../NotImplemented";
import AuthService from "services/auth";

export type FeatureFlag = {
  value: string;
  title: string;
  description: string | null;
};
type FeatureFlags = {
  [key: string]: FeatureFlag;
};
export const FEATURE_FLAGS: FeatureFlags = {
  // TASK_TWO_PANEL_LAYOUT: {
  //   value: "faye.task-two-panel-layout",
  //   title: "Task Two Panel Layout",
  //   description: "Enables the two-panel layout for task pages.",
  // },
  // TASK_ASSIGNMENTS: {
  //   value: "faye.task-assignments",
  //   title: "Task Assignments",
  //   description: "Enables task assignment features.",
  // },
  // ONBOARDING_MODULES: {
  //   value: "faye.member-onboarding-modules",
  //   title: "Member Onboarding Modules",
  //   description: "Enables the member onboarding modules.",
  // },
  // EMAIL_FOLDERS: {
  //   value: "faye.email-folders",
  //   title: "Email Folders",
  //   description: "Enables email folders.",
  // },
  // FEATURED_DOCUMENTS: {
  //   value: "faye.featured-documents",
  //   title: "Featured Documents",
  //   description: "Enables the featured documents feature.",
  // },
  // PICTURE_IN_PICTURE: {
  //   value: "faye.picture-in-picture",
  //   title: "Picture in Picture",
  //   description:
  //     "Enables documents to be displayed in a separate movable window.",
  // },
  // FAMILY_DASHBOARD: {
  //   value: "faye.family-dashboard",
  //   title: "Family Dashboard",
  //   description: "Enables the family dashboard.",
  // },
  // ONBOARDING_MODULES: {
  //   value: "faye.onboarding-modules",
  //   title: "Onboarding Modules",
  //   description: "Enables the onboarding modules.",
  // },
  // MESSAGE_AUTOREPLIES: {
  //   value: "faye.message-autoreplies",
  //   title: "Message autoreplies",
  //   description: "Enables suggesting automatic responses.",
  // },
  // EMAIL_AUTOREPLIES: {
  //   value: "faye.email-autoreplies",
  //   title: "Email autoreplies",
  //   description: "Enables suggesting automatic responses.",
  // },
  // ADVISOR_PAYMENT_MANAGEMENT: {
  //   value: "faye.advisor-payment-management",
  //   title: "Management payments",
  //   description: "Managed linked accounts for payments.",
  // },
  // RECOMMENDATIONS_ON_TASKS: {
  //   value: "faye.recommendations-on-tasks",
  //   title: "Recommendations on Tasks",
  //   description: "Recommendations from the forum displayed on tasks.",
  // },
  // CALENDAR: {
  //   value: "faye.calendar",
  //   title: "Calendar UX",
  //   description: "View the new calendar UX.",
  // },
  // FAMILY_SETTINGS: {
  //   value: "faye.family-settings",
  //   title: "Enables family settings tab.",
  //   description: "Enables .",
  // },
  // SCHEDULED_MESSAGES: {
  //   value: "faye.schedule-messages",
  //   title: "Scheduled Messages",
  //   description: "Scheduled text messages.",
  // },
  // GROUP_CALLS: {
  //   value: "faye.group-calls",
  //   title: "Group Calls",
  //   description: "Allows calling all family members in a conference call.",
  // },
  // GROUP_SMS: {
  //   value: "faye.group-sms",
  //   title: "Group SMS",
  //   description: "Exchange group messages with family members.",
  // },
  // Not deleting these because they are still in the localstorage namespace.
  // EVENTS: {
  //   value: "faye.calendar-events",
  //   title: "Calendar Events",
  //   description: "Events on family pages and a standalone calendar page.",
  // },
  // CATEGORIES: {
  //   value: "faye.categories",
  //   title: "Recommendations and Categories",
  //   description: "Enables the category and subcategory features of the forum.",
  // },
  // DMS: {
  //   value: "faye.direct-messaging",
  //   title: "Direct Messaging",
  //   description: "Enables direct messaging for advisors..",
  // },
  // CALENDER_REMINDERS: {
  //   value: "faye.calendar-reminders",
  //   title: "Calendar Reminders",
  //   description: "Enables reminder notifications for calendar events",
  // },
  // DOCUMENTS: {
  //   value: "faye.documents",
  //   title: "Documents",
  //   description: "The next generation of documents",
  // },
  // CLIENT_DOCUMENTS: {
  //   value: "faye.client-documents",
  //   title: "Client Documents",
  //   description: "Enables client-specific documents interface",
  // },
  // CLIENT_AI_TASKS: {
  //   value: "faye.client-ai-tasks",
  //   title: "Client AI Tasks",
  //   description: "Enables client-specific AI tasks",
  // },
};

export const isFeatureEnabled = (featureName: string) => {
  const currentUser = AuthService.getCurrentUser();
  return currentUser?.enabledFeatureFlags?.includes(featureName) || false;
};

type Props = {
  featureName: string;
  children: ReactNode;
  returnNull?: boolean;
};
export default ({ featureName, children, returnNull }: Props) => {
  const [isEnabled, setIsEnabled] = useState<boolean>(false);

  useEffect(() => {
    const val = isFeatureEnabled(featureName);
    if (val) {
      setIsEnabled(true);
    }
  }, []);

  if (!isEnabled) {
    return returnNull ? null : <NotImplemented name="Feature" />;
  }
  return <>{children}</>;
};
